import { Modal, Button } from 'react-bootstrap';
import React from 'react';
import AnexarComprovante from '~/Pages/AnexarComprovante';
import { FaWindowClose } from 'react-icons/fa';
const ModalAnexarComprovante = ({
  mostrarModal,
  setMostrarModal,
  linhaSelecionada,
}) => {
  return (
    <Modal
      show={mostrarModal}
      onHide={() => setMostrarModal(false)}
      size={'xl'}
      backdrop="static"
      dialogClassName="modal-anexar-comprovante"
    >
      <Modal.Header closeButton className="modal-anexar-comprovante__header">
        <Modal.Title>Anexar comprovante</Modal.Title>
      </Modal.Header>
      <Modal.Body
        className="modal-anexar-comprovante__body"
        style={{
          maxHeight: '70vh',
          overflowY: 'auto',
        }}
      >
        <AnexarComprovante
          match={{
            params: {
              ge: String(linhaSelecionada.ge_cliente.split(' / ')[0]),
              prevenda: String(linhaSelecionada.pre_venda),
              empreendimento: Object({
                quadra: linhaSelecionada.qd,
                lote: linhaSelecionada.lt,
                nome: linhaSelecionada.empreendimento,
                codigo: linhaSelecionada.codigo_familia,
              }),
            },
          }}
        />
      </Modal.Body>
      <Modal.Footer className="modal-anexar-comprovante__footer">
        <>
          <Button
            variant={'light'}
            type="button"
            className="d-inline-flex align-items-center"
            onClick={() => {
              setMostrarModal(false);
            }}
          >
            <FaWindowClose />
            <span className="ml-2 d-xs-none">Fechar</span>
          </Button>
        </>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalAnexarComprovante;
